// Venue-search VS1.3, VS1.4: the shared look of the venue editor's new sections
// (VenueFactFields.js, InventoryFields.js).
import styled from 'styled-components';

import { colors } from '../../styles';

export const SectionTitle = styled.div`
  font-weight: 500;
  font-size: 16px;
  margin: 24px 0 12px;
`;

export const Intro = styled.div`
  font-size: 13px;
  color: ${colors.fadedText};
  margin: -4px 0 12px;
`;

export const Help = styled.div`
  font-size: 12px;
  color: ${colors.fadedText};
  margin-top: 4px;
`;

export const ErrorText = styled.div`
  font-size: 12px;
  color: ${colors.errorColor};
  margin-top: 4px;
`;

export const Pills = styled.div`
  display: flex;
  gap: 8px;

  label {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-height: 36px;
    padding: 0 14px;
    border: 1px solid ${({ $error }) => ($error ? colors.errorColor : colors.defaultBorder)};
    border-radius: 18px;
    font-size: 14px;
    cursor: pointer;
  }

  input {
    margin: 0;
  }
`;

export const Checks = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
  gap: 8px 16px;
  margin: 4px 0 8px;

  label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    cursor: pointer;
  }
`;

export const Indent = styled.div`
  margin: 4px 0 8px 24px;
`;
